<template>
  <div id="app">
    <router-view class="view"></router-view>
    <modals-container />
  </div>
</template>

<script>
  export default {
    name: 'app'
  };
</script>

<style lang="scss" scoped>
  .main {
    display: flex;
    flex-direction: row;

    @media screen and (max-width: 990px) {
      flex-direction: column;
    }
  }
</style>

<style lang="scss">
  @import '~reset-css/sass/reset';
  @import 'scss/fonts';
  @import 'scss/variables';

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  :root {
    font-size: 10px;
  }

  #app {
    font-size: 2.5rem;
    font-family: $main-font;
    color: $main-font-color;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    min-width: 320px;

    /* stylelint-disable-next-line */
    .v--modal-overlay {
      background: $backdrop-color;

      .vue-modal {
        background-color: transparent;
        box-shadow: none;
      }
    }
  }

  p {
    padding: 0;
    margin: 0;
  }

  a:focus,
  button:focus {
    outline: none;
  }
</style>
